"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Row;
var _react = _interopRequireDefault(require("react"));
var _rowConfig = require("./row-config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Row(props) {
  const rowConfig = (0, _rowConfig.useRowConfig)();
  const children = rowConfig.length ? _react.default.Children.map(props.children, (child, i) => /*#__PURE__*/_react.default.cloneElement(child, rowConfig[i])) : props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, children);
}